package org.example.project.planner.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.ui.components.AppFilterChip
import org.example.project.ui.icons.AppIcons
import org.example.project.ui.theme.LocalPlayfulShapes
import org.example.project.ui.theme.PlayfulColors

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun AddBlockTypeDialog(
    startTime: String,
    endTime: String,
    onSelectCatalog: () -> Unit,
    onSelectCustom: () -> Unit,
    onSelectOther: (String) -> Unit,
    onDismiss: () -> Unit
) {
    val shapes = LocalPlayfulShapes.current

    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Column {
                Text(
                    text = "Dodaj punkt programu",
                    fontSize = 18.sp,
                    fontWeight = FontWeight.Bold,
                    color = PlayfulColors.TextPrimary
                )
                if (startTime.isNotBlank() && endTime.isNotBlank()) {
                    Spacer(modifier = Modifier.height(2.dp))
                    Text(
                        text = "Zakres czasu: $startTime – $endTime",
                        fontSize = 12.sp,
                        color = PlayfulColors.TextSecondary
                    )
                }
            }
        },
        text = {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .verticalScroll(rememberScrollState()),
                verticalArrangement = Arrangement.spacedBy(10.dp)
            ) {
                // Option 1: Catalog Game
                Card(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { onSelectCatalog() },
                    shape = shapes.cardSmall,
                    colors = CardDefaults.cardColors(containerColor = PlayfulColors.TealLight),
                    border = BorderStroke(1.dp, PlayfulColors.TealBorder)
                ) {
                    Row(
                        modifier = Modifier.padding(12.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Surface(
                            color = PlayfulColors.Teal,
                            shape = shapes.pill,
                            modifier = Modifier.size(36.dp)
                        ) {
                            Icon(
                                imageVector = AppIcons.Catalog,
                                contentDescription = null,
                                tint = PlayfulColors.TextOnPrimary,
                                modifier = Modifier
                                    .padding(8.dp)
                                    .size(20.dp)
                            )
                        }
                        Spacer(modifier = Modifier.width(10.dp))
                        Column(modifier = Modifier.weight(1f)) {
                            Text(
                                text = "Zabawa z katalogu",
                                fontWeight = FontWeight.Bold,
                                fontSize = 14.sp,
                                color = PlayfulColors.TealDark
                            )
                            Text(
                                text = "Wybierz spośród opublikowanych zabaw w bazie",
                                fontSize = 11.sp,
                                color = PlayfulColors.TextSecondary
                            )
                        }
                    }
                }

                // Option 2: Custom Game
                Card(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { onSelectCustom() },
                    shape = shapes.cardSmall,
                    colors = CardDefaults.cardColors(containerColor = PlayfulColors.LilacLight),
                    border = BorderStroke(1.dp, PlayfulColors.LilacBorder)
                ) {
                    Row(
                        modifier = Modifier.padding(12.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Surface(
                            color = PlayfulColors.Lilac,
                            shape = shapes.pill,
                            modifier = Modifier.size(36.dp)
                        ) {
                            Icon(
                                imageVector = AppIcons.Users,
                                contentDescription = null,
                                tint = PlayfulColors.TextOnPrimary,
                                modifier = Modifier
                                    .padding(8.dp)
                                    .size(20.dp)
                            )
                        }
                        Spacer(modifier = Modifier.width(10.dp))
                        Column(modifier = Modifier.weight(1f)) {
                            Text(
                                text = "Własna zabawa",
                                fontWeight = FontWeight.Bold,
                                fontSize = 14.sp,
                                color = PlayfulColors.LilacDark
                            )
                            Text(
                                text = "Wpisz własny tytuł, zasady i opis zabawy",
                                fontSize = 11.sp,
                                color = PlayfulColors.TextSecondary
                            )
                        }
                    }
                }

                // Option 3: Other / Breaks / Meal
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = shapes.cardSmall,
                    colors = CardDefaults.cardColors(containerColor = PlayfulColors.SunYellowLight),
                    border = BorderStroke(1.dp, PlayfulColors.SunYellowBorder)
                ) {
                    Column(modifier = Modifier.padding(12.dp)) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Surface(
                                color = PlayfulColors.SunYellowDark,
                                shape = shapes.pill,
                                modifier = Modifier.size(36.dp)
                            ) {
                                Icon(
                                    imageVector = AppIcons.Clock,
                                    contentDescription = null,
                                    tint = PlayfulColors.TextOnPrimary,
                                    modifier = Modifier
                                        .padding(8.dp)
                                        .size(20.dp)
                                )
                            }
                            Spacer(modifier = Modifier.width(10.dp))
                            Column {
                                Text(
                                    text = "Inny punkt programu",
                                    fontWeight = FontWeight.Bold,
                                    fontSize = 14.sp,
                                    color = PlayfulColors.SunYellowDark
                                )
                                Text(
                                    text = "Szybki wybór lub własny punkt",
                                    fontSize = 11.sp,
                                    color = PlayfulColors.TextSecondary
                                )
                            }
                        }

                        Spacer(modifier = Modifier.height(10.dp))

                        // Quick Chips: Jedzenie, Tort, Przerwa
                        FlowRow(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(8.dp),
                            verticalArrangement = Arrangement.spacedBy(6.dp)
                        ) {
                            AppFilterChip(
                                label = "Jedzenie",
                                selected = false,
                                onClick = { onSelectOther("Jedzenie") }
                            )
                            AppFilterChip(
                                label = "Tort",
                                selected = false,
                                onClick = { onSelectOther("Tort") }
                            )
                            AppFilterChip(
                                label = "Przerwa",
                                selected = false,
                                onClick = { onSelectOther("Przerwa") }
                            )
                            AppFilterChip(
                                label = "+ Własny...",
                                selected = false,
                                onClick = { onSelectOther("") }
                            )
                        }
                    }
                }
            }
        },
        confirmButton = {},
        dismissButton = {
            TextButton(
                onClick = onDismiss,
                shape = shapes.buttonSmall
            ) {
                Text("Anuluj", fontSize = 13.sp, color = PlayfulColors.TextSecondary)
            }
        },
        shape = shapes.dialog,
        containerColor = PlayfulColors.Surface
    )
}
